module.exports = __webpack_public_path__ + "img/jurklee.c02094f8.png";